// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3mom7","label":"Radio_label__3bE48","checkMark":"Radio_checkMark__2713p","disabled":"Radio_disabled__3kmIR"};